<div *ngIf="zcVersionStatistic; else no_zc_version">

    <ng-container *ngIf="data">
        <h2>Zoning code statistic</h2>
    </ng-container>

    <div class="mat-typography">
        <div class="mat-typography content">
            <p>Zoning code records: {{ zcVersionStatistic.zoningCodeRecords }}</p>
            <p>Total property records: {{
                zcVersionStatistic.totalPropertyRecords }}</p>
            <p>Property records left: {{
                zcVersionStatistic.currentExpectedRecords }}</p>
            <p>Progress: {{ zcVersionStatistic.progress }}%</p>

            <div *ngIf="zcVersionStatistic.statsByStatus">
                <app-process-stats-by-status-section [process]="zcVersionStatistic" [smallTitle]="true"
                    [showRatio]="true"></app-process-stats-by-status-section>
                <div class="open-chart" (click)="isOpenChart = !isOpenChart">
                    <mat-icon class="open-arrow" [class.arrow-rotate]="isOpenChart">chevron_right</mat-icon>
                    <span>Chart</span>
                </div>
                <radio-bar-chart [chartData]="zcVersionStatistic.statsByStatus" *ngIf="isOpenChart"></radio-bar-chart>
            </div>

            <br *ngIf="zcVersionStatistic.statsByActuality">
            <p *ngIf="zcVersionStatistic.statsByActuality" style="margin-bottom: 0px">Statistic by actuality: {{
                zcVersionStatistic.totalPropertyRecords}}
            </p>
            <div *ngIf="zcVersionStatistic.statsByActuality">
                <div *ngFor="let actuality of zcVersionStatistic.statsByActuality">
                    {{ getCalculationStatusActualityById(actuality.actuality) }}: {{ actuality.count }}
                </div>
            </div>
            <h4 class="statistic-section-header">Latest processes
                statistic<app-events-stat-hint-icon class="stat-hint-icon"
                    placement="right"></app-events-stat-hint-icon></h4>

            <div style="width: 100%; display: flex;">
                <div style="flex-direction: column;" class="mat-typography labeled-events-stat-container">
                    <span class="statistic-section-sub-header">Last Calculation:</span><app-events-stat-component
                        #calcEventsStatistic [statistic]="zcVersionStatistic?.lastCalculationStat" [stateEnv]="stateEnv"
                        [hideRefreshButton]="true" style="width: 100%;"
                        [showInColumn]="true"></app-events-stat-component>
                </div>
                <div style="flex-direction: column;" class="mat-typography labeled-events-stat-container">
                    <span class="statistic-section-sub-header">Last Indexation:</span><app-events-stat-component
                        #indexEventsStatistic [statistic]="zcVersionStatistic?.lastIndexationStat" [stateEnv]="stateEnv"
                        [hideRefreshButton]="true" style="width: 100%;"
                        [showInColumn]="true"></app-events-stat-component>
                </div>
            </div>

            <h4 class="statistic-section-header" style="display: flex;">Missed GAPI data
                Statistic<app-update-zcv-status-button [zoningCodeVersion]="zoningCodeVersion" [stateEnv]="stateEnv"
                    style="top:-2px; margin-left: 5px; position: relative;"></app-update-zcv-status-button>
            </h4>
            <app-prs-missed-entities-view [zcMetaData]="zoningCodeVersion?.MetaData"></app-prs-missed-entities-view>
        </div>
    </div>
</div>

<ng-template #no_zc_version>
    <h2>Zoning code version not found</h2>
</ng-template>